import { render, staticRenderFns } from "./8march.vue?vue&type=template&id=c67606e4&scoped=true&"
import script from "./8march.vue?vue&type=script&lang=js&"
export * from "./8march.vue?vue&type=script&lang=js&"
import style0 from "./8march.vue?vue&type=style&index=0&id=c67606e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67606e4",
  null
  
)

export default component.exports